import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ValidationService } from '../../../common/validationservice';
import { MainAppComponent } from '../../../layout/layout.component';
import { PagerService } from '../../../common/pagerService';
import { UserTypeModel } from '../../../common/viewModels/Admin/UserModel';
import { LabModel } from '../../../common/viewModels/Admin/LabModel';
import { CustomerModel } from '../../../common/viewModels/Admin/CustomerModel';
import { RolesModel } from '../../../common/viewModels/Admin/UserModel';
import { UserModel } from '../../../common/viewModels/Admin/UserModel';
import { UserTypes } from '../../../common/enumcontainer.enum';
import { AmplifyService } from '../../../common/amplify-service';
import 'rxjs/add/operator/map'

@Component({
  selector: 'app-userlist',
  templateUrl: './userlist.component.html',
  styleUrls: ['./userlist.component.css']
})
export class UserlistComponent implements OnInit {

  userTypes: UserTypeModel;
  labs: any;
  customers: CustomerModel;
  roles: RolesModel;
  message: string;
  id: number;
  searchFields: UserModel = new UserModel();
  lstUsers: UserModel[];
  model: UserModel = new UserModel();
  userSearchForm: FormGroup;
  total: number;
  value: string;
  isNoRecords: boolean = true;
  pager: any = {};
  pagedItems: any[];
  length: number = 0;
  showLabs: boolean = true;
  showCustomers: boolean = false;
  mainComponent: any;
  pageSize: number = 10;
  constructor(public _router: Router, private _formBuilder: FormBuilder,
    private _http: CustomHttp,
    private _appUrl: ApiUrl, private _route: ActivatedRoute,
    private _validationService: ValidationService, private _mApp: MainAppComponent, private _pageSrvc: PagerService,
    private _toastrService: ToastrService, private _amplifyService: AmplifyService) {
    this.mainComponent = _mApp;
  }

  ngOnInit() {
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
    this.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
    this.pager.pageSize = this.pageSize;
    this.pager.pageIndex = 0;
    this.pager.pageSizeOptions = this._pageSrvc.pageSizeOptions;
    this.CreateForm();
    if (curUserDetails && curUserDetails.LabIds) {
      this.userSearchForm.controls['LabIds'].setValue(JSON.parse(curUserDetails.LabIds));
    }
    this.GetUserTypes();
    this.GetDataFromAmpliy();
    this.setPage(this.pager);
    this.ClearDataInAmplify();
  }
  GetUserTypes() {
    this._http.get(this._appUrl.GetUserTypes)
      .subscribe(
        data => {
          if (data.json().Result != null)
            this.userTypes = data.json().Result
        },
        error => {
          this._toastrService.error(error.json().Result, '')
        }
      )
  }


  CreateForm() {
    this.model = new UserModel();
    this.userSearchForm = this._formBuilder.group({
      UserTypeId: [''],
      CustomerId: [''],
      LabIds: [''],
      RoleId: [''],
      FullName: [''],
    })
  }

  GetLabs() {
    this._http.get(this._appUrl.GetLabsMinInfoList)
      .subscribe(
        data => {
          let lstLabs = data.json().Result;
          if (this._mApp.currentUserLabIds && lstLabs)
            lstLabs = lstLabs.filter(m => this._mApp.currentUserLabIds.includes(m.LabId));
          this.labs = lstLabs;
        },
        error => {
          this._toastrService.error(error.json())
        }
      )
  }

  GetCustomers() {
    this._http.get(this._appUrl.GetCustomersMinInfoList)
      .subscribe(
        data => {
          if (data.json().Result != null)
            this.customers = data.json().Result;
        },
        error => {
          this._toastrService.error(error.json().Result, '')
        }
      )
  }

  GetRoles(id: number) {
    this._http.get(this._appUrl.GetRoles + id)
      .subscribe(
        data => {
          this.roles = data.json().Result;
        },
        error => {
          this._toastrService.error(error.json().Result, '')
        }
      )
  }

  BindCompanyData(val) {
    this.GetRoles(val);
    switch (val) {
      case UserTypes.SuperUser:
        this.showLabs = false;
        this.showCustomers = false;
        break;
      case UserTypes.LabUser:
        this.showLabs = true;
        this.showCustomers = false;
        this.userSearchForm.controls['CustomerId'].reset();
        this.userSearchForm.controls['LabIds'].reset();
        this.GetLabs();
        break;
      case UserTypes.ClientUser:
        this.showLabs = false;
        this.showCustomers = true;
        this.userSearchForm.controls['CustomerId'].reset();
        this.userSearchForm.controls['LabIds'].reset();
        this.GetCustomers();
        break;
    }
  }

  onSubmit() {
    this.pager.pageIndex = 0;
    this.ConstructSearchData();
    this.setPage(this.pager);
  }

  ConstructSearchData() {
    let searchDto = this.userSearchForm.value;
    this.searchFields.LabIds = searchDto.LabIds;
    if (searchDto.UserTypeId != null)
      this.searchFields.UserTypeId = searchDto.UserTypeId;
    if (searchDto.RoleId != null)
      this.searchFields.RoleId = searchDto.RoleId;
    if (searchDto.FullName != null)
      this.searchFields.FullName = searchDto.FullName;
    if (searchDto.CustomerId != null)
      this.searchFields.CustomerId = searchDto.CustomerId;
  }

  OnReset() {
    this.userSearchForm.reset();
    this.labs = null;
    this.customers = null;
    this.roles = null;
    this.CreateForm();
    this.searchFields.UserTypeId = 0;
    this.pager.pageSize = this._mApp.pageSize;
    this.pager.pageIndex = 0;
    this.searchFields.RoleId = 0;
    this.searchFields.FullName = '';
    this.searchFields.LabIds = [];
    this.setPage(this.pager);
  }

  BindUsersDetails(page: any) {
    
    this.searchFields.PageNo = page.pageIndex;
    this.searchFields.PageSize = page.pageSize;
    this._mApp.ShowLoader();
    this._http.post(this._appUrl.GetUserList, this.searchFields)
      .subscribe(
        data => {
          this._mApp.HideLoader();
          var response = data.json();
          this.pagedItems = response.Result;
          this.length = response.PageResult.TotalRecords;
          this.isNoRecords = !(response.Result.length > 0)
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, "")
        }
      )
  }

  setPage(page: any) {
    this.pager.pageSize = page.pageSize;
    this.pager.pageIndex = page.pageIndex;
    this.BindUsersDetails(this.pager);
  }

  DeleteUser(id: any) {
    this.id = id;
  }

  DeleteUserById(id) {
    this.SaveDataInAmplify();
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.DeleteUser + id)
      .subscribe(
        data => {
          this._mApp.HideLoader();
          this.GetDataFromAmpliy();
          this.setPage(this.pager);
          this._toastrService.success(data.json().Result, '');
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      )
  }

  SaveDataInAmplify() {
    this._amplifyService.SetStorage('usersList', this.userSearchForm.value);
    this._amplifyService.SetStorage('usersList_PageNo', this.pager.pageIndex);
    this._amplifyService.SetStorage('usersList_PageSize', this.pager.pageSize);
  }


  GetDataFromAmpliy() {
    let storedData = this._amplifyService.GetStorage('usersList');
    if (storedData != undefined && storedData != null) {
      if (storedData.UserTypeId > 0)
        this.BindCompanyData(storedData.UserTypeId);
      this.userSearchForm.setValue(storedData);
      this.ConstructSearchData();
    }
    // let savedPageSize = this._amplifyService.GetStorage('usersList_PageSize');
    // this.pager.pageSize = savedPageSize > 0 ? savedPageSize : this._pageSrvc.pageSize;
    let pageIndex = this._amplifyService.GetStorage('usersList_PageNo');
    if (pageIndex != null && pageIndex != '' && pageIndex != undefined)
      this.pager.pageIndex = pageIndex;
    else
      this.pager.pageIndex = 0;
  }

  ClearDataInAmplify() {
    this._amplifyService.ClearStorage('usersList');
    this._amplifyService.ClearStorage('usersList_PageNo');
    this._amplifyService.ClearStorage('usersList_PageSize');
  }
}
